import _ from "lodash";

export const compareFloatWithOperator = (_value1, _operator, _value2) => {

  switch (_operator) {
    case "equal":
      return (_value1 == _value2);
    case "notEqual":
      return (_value1 != _value2);   
    case "lowerThan":
      return (_value1 < _value2);
    case "lowerEqual":
      return (_value1 <= _value2);
    case "greaterThan":
      return (_value1 > _value2);
    case "greaterEqual":
      return (_value1 >= _value2);
    default:
      return false;
  }

};

export const isValidEmail = (_email) =>
{
  // Regular expression pattern for email validation
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Test the email against the pattern
  return emailPattern.test(_email);
}


export const applyListFilterAndSort = (_data, _column, _sort) =>
{

  let data = applyListFilter(_data, _column);

  data = applyListSort(data, _sort);

  return data;

}

export const applyListFilter = (_data, _column) =>
{


  let data = _.cloneDeep(_data);

  data.forEach(d =>
  {
    d.bFiltered = false;
  });


  _column.filter(col => !(col.filterOperator === "like" && col.filterValue === "")).forEach(col =>
  {

    if (col.filterValue || col.filterValue == 0)
    {

      let fValue = (typeof col.filterValue === 'string') ? col.filterValue.toLowerCase() : col.filterValue;

      if (col.format == "boolean") fValue = fValue == "true" ? true : false;


      data.filter(d => !d.bFiltered).forEach((d, i) =>
      {

        //Split value if . found
        let dValue = "";

        let splittedProperty = col.property.split(".");

        splittedProperty.forEach((p, index) =>
        {
          if (index == 0)
            dValue = d[p];
          else
            dValue = dValue ? dValue[p] : undefined;
        });


        if (dValue || col.filterValue == 0)
        {



          dValue = (typeof dValue === 'string') ? dValue.toLowerCase() : dValue;

          switch (col.filterOperator)
          {
            case "like":
              if (dValue.toString().indexOf(fValue) === -1)
              {
                d.bFiltered = true;
              }
              break;
            case "notlike":
              if (dValue.toString().indexOf(fValue) > -1)
              {
                d.bFiltered = true;
              }
              break;
            case "=":
              if (dValue !== fValue)
              {
                d.bFiltered = true;
              }
              break;
            case "!=":
              if (dValue === fValue)
              {
                d.bFiltered = true;
              }
              break;
            case ">":
              if (dValue <= fValue)
              {
                d.bFiltered = true;
              }
              break;
            case "<":
              if (dValue >= fValue)
              {
                d.bFiltered = true;
              }
              break;
            default:
              break;
          }
        } else
        {
          if (fValue && fValue != "")
            d.bFiltered = true;
        }

      });
    }
  });

  return data;
};

//Sort Data from listcomponent
export const applyListSort = (_data, _sort) =>
{

  let data = _.cloneDeep(_data);

  if (_sort.property !== "")
  {
    const up = _sort.direction * -1;
    const down = _sort.direction * 1;
    const property = _sort.property;

    let splittedProperty = property.split(".");


    data = data.sort((a, b) =>
    {
      let valueA = undefined;
      let valueB = undefined;

      // eslint-disable-next-line array-callback-return
      splittedProperty.some((p, index) =>
      {
        if (index == 0)
        {
          valueA = a[p];
          valueB = b[p];
        } else
        {
          valueA = valueA ? valueA[p] : undefined;
          valueB = valueB ? valueB[p] : undefined;
        }

      });



      if (valueA === null || valueA === undefined) return down;
      if (valueB === null || valueB === undefined) return up;

      if (valueA > valueB) return up;
      if (valueA < valueB) return down;

      return 0;
    });

  }

  return data;
}


//Get all steps leading to current step.
export const getPathToStep = (_currentStep, _step) => {


  let parentStep = _step.filter(s => s.condition.findIndex(c => c.processStep == _currentStep._id) > -1) 

  parentStep = LoopParentPath(parentStep, _step, parentStep)


    
  return parentStep;

};

const LoopParentPath = (_parentStep, _step, _returnStep) => {


  _parentStep.forEach(sp =>
  {
    let currentParent = _step.filter(s => s.condition.findIndex(c => c.processStep == sp._id) > -1 && _returnStep.findIndex(r => r._id == s._id) == -1);

    _returnStep = [..._returnStep, ...currentParent];

    _returnStep = LoopParentPath(currentParent, _step, _returnStep);


  });

  return _returnStep;



};


// Format UTC datetime to local datetime string in YYYY-MM-DD HH:mm:ss format
export const formatUTCToLocal = (utcDateString) => {
  if (!utcDateString) return '';
  
  try {
    const date = new Date(utcDateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) return '';
    
    // Format as YYYY-MM-DD HH:mm:ss
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

export const getPathFromStep = (_currentStep, _step) => {

  let childStep = [];

  _currentStep.condition.forEach(c => {

    let currentStep = _step.find(s => s._id == c.processStep);

    if (currentStep) childStep.push(currentStep);

  });

  childStep = LoopChildPath(childStep, _step, childStep);


  return childStep;

};

const LoopChildPath = (_childStep, _step, _returnStep) =>
{


  _childStep.forEach(sc =>
  {

    let currentChild = [];

    sc.condition.forEach(c =>
    {

      let currentStep = _step.find(s => s._id == c.processStep);


      

      if (currentStep && _returnStep.findIndex(r => r._id == currentStep._id) == -1) {

        currentChild.push(currentStep);
        _returnStep.push(currentStep);

      }
      

    });    

    _returnStep = LoopChildPath(currentChild, _step, _returnStep);


  });

  return _returnStep;



};

